import { isMacOs } from './isMacOs';

/** The v11 multi-selection key: Meta on macOS, Control elsewhere. */
export const isMultiSelectEvent = (event: { metaKey: boolean; ctrlKey: boolean }): boolean =>
  isMacOs() ? event.metaKey : event.ctrlKey;
